import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { isNil } from 'lodash-es';

export function createPhoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (isNil(value)) {
      return null;
    }

    if (isValidPhoneNumber(value, 'RO')) {
      return null;
    }

    return { phoneNumberValid: false };
  };
}
